// ============================================================================
// Helpers e dominios compartilhados pelas telas de auditoria de integracao
// (modal por simulacao e pagina global de busca).
// ============================================================================

// Valores de cd_fluxo registrados pelo backend. Cobertura:
//   - simulation, opportunity, documents, participant, follow-up:
//     definidos em routes/external/index.js (AUDITORIA_API_INBOUND)
//   - batch: definido nos FLOW_MATCHERS de bank-integration-auditoria.js
//     (rotas /itau/consulta-massiva e /bradesco/consulta-massiva)
//   - auth, domain, config: tambem definidos em AUDITORIA_API_INBOUND
//   - unknown: fallback aplicado quando o request bancario nao bate em
//     nenhum matcher (ex: chamadas auxiliares como auth/token de banco)
export const FLUXO_DOMAIN = [
  { id: 'simulation', nome: 'Simulação' },
  { id: 'opportunity', nome: 'Proposta' },
  { id: 'documents', nome: 'Documentos' },
  { id: 'participant', nome: 'Participante' },
  { id: 'batch', nome: 'Lote' },
  { id: 'follow-up', nome: 'Follow-up' },
  { id: 'auth', nome: 'Autenticação' },
  { id: 'domain', nome: 'Domínio' },
  { id: 'config', nome: 'Configuração' },
  { id: 'unknown', nome: 'Desconhecido' }
];

export const TIPO_EVENTO_DOMAIN = [
  { id: 'api_inbound', nome: 'API Homefin' },
  { id: 'bank_integration', nome: 'Bancos' }
];

export const SITUACAO_DOMAIN = [
  { id: 'sucesso', nome: 'Sucesso' },
  { id: 'erro', nome: 'Erro' }
];

export const fluxoLabel = (codigo) =>
  FLUXO_DOMAIN.find((f) => f.id === codigo)?.nome ?? codigo ?? '—';

export const formatDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR');
};

export const formatDuracao = (ms) => {
  if (ms === null || ms === undefined) return '—';
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(2)} s`;
};

export const isEncryptedFormat = (format) =>
  typeof format === 'string' && /encrypt/i.test(format);

export const tryFormatJson = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

export const buildServicoLabel = (row) => {
  if (row.tipoEvento === 'api_inbound') {
    return `API Homefin · ${fluxoLabel(row.codigoFluxo)}`;
  }
  const banco = row.codigoBanco
    ? row.codigoBanco.charAt(0).toUpperCase() + row.codigoBanco.slice(1).toLowerCase()
    : 'Banco';
  return `${banco} · ${fluxoLabel(row.codigoFluxo)}`;
};

// Converte 'DD/MM/AAAA' (input do DateTextField) -> 'YYYY-MM-DD' (esperado pelo backend)
export const parseBrDate = (br) => {
  if (!br || typeof br !== 'string') return null;
  const m = br.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  return `${m[3]}-${m[2]}-${m[1]}`;
};

// Converte 'YYYY-MM-DDTHH:mm' (input datetime-local) -> ISO datetime
// (UTC ou com offset local conforme browser). Backend aceita ISO direto.
export const parseLocalDatetime = (local) => {
  if (!local || typeof local !== 'string') return null;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

// Default: ultimas 24h, no formato YYYY-MM-DDTHH:mm (datetime-local).
// Util para inicializar filtros da pagina global.
export const defaultUltimas24h = () => {
  const now = new Date();
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const toLocalInput = (d) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  return { from: toLocalInput(yesterday), to: toLocalInput(now) };
};
